import {
  Directive,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  Output,
} from '@angular/core';
import { SliderCurrencyPipe } from './slider-currency.pipe';

@Directive({
  selector: '[appSliderParseDecimals]',
  // tslint:disable-next-line:use-host-property-decorator
  host: {
    '(keydown)': 'onInputChange($event)',
    '(input)': 'onInputChange($event)',
  },
  standalone: false,
})
export class SliderParseDecimalsDirective {
  // tslint:disable-next-line:no-input-rename
  @Input('decimalSeparator') DECIMAL_SEPARATOR: string;
  @Input('numFraction') numFraction: number;
  @Input('limits') limits: any;
  @Output('updateDecimals') updateDecimals: EventEmitter<string> = new EventEmitter();

  constructor(
    private sliderCurrencyPipe: SliderCurrencyPipe,
    public el: ElementRef,
  ) {
    let langDecimalSeparator: number;

    this.el.nativeElement.onkeypress = (event) => {
      switch (this.DECIMAL_SEPARATOR) {
        case ',':
          langDecimalSeparator = 44;
          break;
        case '.':
          langDecimalSeparator = 46;
          break;
      }

      // Para poder usar las flechas y firefox
      if (event.which === 0 || event.which === 8) {
        return;
      }
      if (
        event.which !== langDecimalSeparator &&
        (event.which < 48 || event.which > 57)
      ) {
        event.preventDefault();
      }
    };

    this.el.nativeElement.onkeyup = (event) => {
      //     if (this.el.nativeElement.value === '') {
      //         return ;
      //     }
      //     if (parseFloat(this.el.nativeElement.value) >= this.limits.min && parseFloat(this.el.nativeElement.value) <= this.limits.max) {
      //         this.updateDecimals.emit(this.el.nativeElement.value);
      //     } else {
      //         this.el.nativeElement.value = this.limits.max;
      //         this.updateDecimals.emit(this.el.nativeElement.value);
      //     }
      //     event.preventDefault();
      // };
    };
  }

  @HostListener('blur', ['$event']) blurAction(event): void {
    // quitar los puntos para que se haga el parseo correctamente cuando tengo el foco en el campo y muevo con el slider
    this.el.nativeElement.value = this.el.nativeElement.value.replace(/\./g, '');

    if (this.el.nativeElement.value === '') {
      this.el.nativeElement.value = 0;
    }

    if (
      parseFloat(this.el.nativeElement.value) >= this.limits.min &&
      parseFloat(this.el.nativeElement.value) <= this.limits.max
    ) {
    } else if (parseFloat(this.el.nativeElement.value) < this.limits.min) {
      this.el.nativeElement.value = this.limits.min;
    } else if (parseFloat(this.el.nativeElement.value) > this.limits.max) {
      this.el.nativeElement.value = this.limits.max;
    }
    event.preventDefault();

    if (this.el.nativeElement.value) {
      this.el.nativeElement.value = parseFloat(this.el.nativeElement.value);

      if ((<string>this.el.nativeElement.value).startsWith(this.DECIMAL_SEPARATOR)) {
        this.el.nativeElement.value = `0${this.el.nativeElement.value}`;
      }

      this.updateDecimals.emit(this.el.nativeElement.value);
      setTimeout(() => {
        // Si no pongo este timeout no se parsea correctamente al hacer onblur
        this.el.nativeElement.value = this.sliderCurrencyPipe.transform(
          this.el.nativeElement.value,
          this.numFraction,
        );
      }, 0);
    }
  }

  @HostListener('focus', ['$event']) focusAction(event): void {
    this.el.nativeElement.value = this.sliderCurrencyPipe.parse(
      this.el.nativeElement.value,
    );
    event.preventDefault();
  }

  onInputChange(event) {
    if (event) {
      const onlyNumbers = event.target.value.replace(/[^0-9]+/g, '');
      onlyNumbers
        ? (event.target.value = parseFloat(onlyNumbers))
        : (event.target.value = onlyNumbers);
    }
  }
}
